import React from 'react'
import NewTable from 'components_new/atoms/Table'
import TableHead from 'components_new/atoms/Table/TableHead'
import TableBody from 'components_new/atoms/Table/TableBody'
import TableCell from 'components_new/atoms/Table/TableCell'
import TableRow from 'components_new/atoms/Table/TableRow'

const Table = (props) => {
  const {
    //size = 'small',
    headers = [],
    rows = [],
    onClick
    // hidden = false,
    // toggle = { items: null, onClick: () => {}, selected: null },
    // selectedRows,
    // setSelectedRows,
    // rowSelectionType,
    // scroll,
    // outerBorder = false,
    // className,
    // loading = false,
    // ellipsis = true,
    // thickHeader,
    // rowHasOnClick = () => true,
    // parsedFormat = false,
    // bordered = false,
    // rowClassName,
    // onClickLabel,
    // thickHeaderClassName,
    // onChange,
    // showTotal = () => {},
    // totalRow,
    // customSort = false,
    // hideOnClick = false,
    // pagination = false,
    // noRowBorder = false,
    // expandable,
    // tableLayout
  } = props

  return (
    <NewTable sx={{ minWidth: 'content' }}>
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <>
              <TableCell>{header.label}</TableCell>
            </>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          return (
            <TableRow
              key={row.key}
              onClick={() => onClick && onClick(row.key, row)}
              sx={{
                cursor: 'pointer',
                '&:hover': { backgroundColor: '#f5f5f5' }
              }}
            >
              {headers.map((header) => {
                const render = header.render
                  ? header.render(row[header.key], row)
                  : row[header.key]

                return <TableCell key={header.key}>{render}</TableCell>
              })}
            </TableRow>
          )
        })}
      </TableBody>
    </NewTable>
  )
}

Table.displayName = 'Table'
export default Table
